export default __webpack_public_path__ + "locales/bg/Settings.json?hash=0e761dacea333a8bdbaa0a1462baef37";